const PortfolioDragTypes = {
  TOPIC: 'TOPIC',
  SUBTOPIC: 'SUBTOPIC',
  PART: 'PART',
  LEVEL: 'LEVEL'
};

export default PortfolioDragTypes;
